const PROVIDERS = [
  { id: "phantom", name: "Phantom", get: () => window.phantom?.solana?.isPhantom && window.phantom.solana },
  { id: "solflare", name: "Solflare", get: () => window.solflare?.isSolflare && window.solflare },
  { id: "backpack", name: "Backpack", get: () => window.backpack?.isBackpack && window.backpack },
];

export const detectWallets = () => PROVIDERS.filter((p) => p.get());

export const openInPhantom = () => `https://phantom.app/ul/browse/${encodeURIComponent(window.location.href)}?ref=${encodeURIComponent(window.location.origin)}`;

export async function connectWallet(id) {
  const p = PROVIDERS.find((x) => x.id === id).get();
  const res = await p.connect();
  const key = res?.publicKey || p.publicKey;
  if (!key) throw new Error("The wallet didn't share its address");
  return { provider: p, address: key.toString() };
}

export async function signTx(provider, b64) {
  const { Transaction } = await import("@solana/web3.js");
  const tx = Transaction.from(Uint8Array.from(atob(b64), (c) => c.charCodeAt(0)));
  const signed = await provider.signTransaction(tx);
  const bytes = signed.serialize({ requireAllSignatures: false, verifySignatures: false });
  return btoa(String.fromCharCode(...new Uint8Array(bytes)));
}

export async function signText(provider, text) {
  const out = await provider.signMessage(new TextEncoder().encode(text), "utf8");
  const sig = out?.signature || out;
  return btoa(String.fromCharCode(...new Uint8Array(sig)));
}
